// Lightweight, flexible i18n type and helpers
import * as Localization from 'expo-localization'
import es from './es/es.js'
import en from './english/en.js'
import ar from './arabe/ar.js'
import az from './azeri/az.js'
import fr from './frances/fr.js'
import hi from './hindi/hi.js'
import id from './indonesio/id.js'
import kk from './kazajo/kk.js'
import pt from './portugues/pt.js'
import ru from './ruso/ru.js'
import tr from './turco/tr.js'
import uz from './uzbeko/uz.js'
import vi from './vi/vi.js'

export type LanguageFile = Record<string, string>

const LANGUAGES: Record<string, LanguageFile> = {
    es: es as unknown as LanguageFile,
    en: en as unknown as LanguageFile,
    ar: ar as unknown as LanguageFile,
    az: az as unknown as LanguageFile,
    fr: fr as unknown as LanguageFile,
    hi: hi as unknown as LanguageFile,
    id: id as unknown as LanguageFile,
    kk: kk as unknown as LanguageFile,
    pt: pt as unknown as LanguageFile,
    ru: ru as unknown as LanguageFile,
    tr: tr as unknown as LanguageFile,
    uz: uz as unknown as LanguageFile,
    vi: vi as unknown as LanguageFile,
}

const locales = typeof Localization.getLocales === 'function' ? Localization.getLocales() : []
const defaultLang = (locales && locales[0] && (locales[0] as any).languageCode) ? (locales[0] as any).languageCode : 'es'
let currentLang = defaultLang
let languageFile: LanguageFile = LANGUAGES[currentLang] || (es as unknown as LanguageFile)

export function setLanguage(lang: string) {
    currentLang = lang
    languageFile = LANGUAGES[lang] || (es as unknown as LanguageFile)
}

export function getLanguageFile(): LanguageFile {
    return languageFile
}
 
